import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import InsightList from './list';
import Person from '../../../forecast-app/shared/components/person/person';
import Util from '../../../forecast-app/shared/util/util';

class CardListPortfolioDummy extends Component {
	createDummyCard(
		id,
		name,
		companyProjectId,
		projectName,
		sprint,
		phase,
		cardStatus,
		forecast,
		remaining,
		reported,
		startDate,
		deadline,
		assigned,
		bug,
		blocked,
		billable
	) {
		const card = {};
		card.id = 'T' + id;
		card.name = name;
		card.companyProjectId = companyProjectId;
		card.projectName = projectName;
		card.sprint = sprint;
		card.phase = phase;
		card.cardStatus = cardStatus;
		card.low = Util.convertMinutesToFullHour((forecast - 1) * 60, this.props.intl);
		card.high = Util.convertMinutesToFullHour((forecast + 2) * 60, this.props.intl);
		card.forecast = Util.convertMinutesToFullHour(forecast * 60, this.props.intl);
		card.remaining = Util.convertMinutesToFullHour(remaining * 60, this.props.intl);
		card.reported = Util.convertMinutesToFullHour(reported * 60, this.props.intl);
		card.startDate = this.props.intl.formatDate(new Date(startDate));
		card.deadline = this.props.intl.formatDate(new Date(deadline));
		card.assigned = (
			<Person name={assigned} role="Developer" showName={false} showRole={false} imageSrc={null} imageSize="medium" />
		);
		card.bug = bug;
		card.blocked = blocked;
		card.billable = billable;
		card.labels = [{id: 1, color: '#392664', name: 'Label 1'}];

		const progress = forecast > 0 ? Math.min(Math.max(((forecast - remaining) / forecast) * 100, 0), 100) : 0;

		card.progress = (
			<div className="progress-container" style={{border: '1px solid rgb(68, 180, 255)'}}>
				<div className="progress-indicator" style={{width: progress + '%', backgroundColor: 'rgb(68, 180, 255)'}} />
			</div>
		);
		return card;
	}

	render() {
		const {formatMessage} = this.props.intl;
		let cards = [];
		cards.push(
			this.createDummyCard(
				1,
				'Example card 1',
				'P-1',
				'Project 1',
				formatMessage({id: 'project_sprints.backlog'}),
				'Phase 1',
				formatMessage({id: 'common.to_do'}),
				5,
				5,
				0,
				'5 8 2017',
				'12 8 2017',
				'John Smith',
				formatMessage({id: 'common.yes'}),
				formatMessage({id: 'common.no'}),
				formatMessage({id: 'common.yes'})
			)
		);
		cards.push(
			this.createDummyCard(
				2,
				'Example card 2',
				'P-1',
				'Project 1',
				'Sprint 1',
				'Phase2',
				formatMessage({id: 'project_settings.workflow-done'}),
				3,
				0,
				3,
				'11 20 2017',
				'11 25 2017',
				'John Smith',
				formatMessage({id: 'common.no'}),
				formatMessage({id: 'common.yes'}),
				formatMessage({id: 'common.no'})
			)
		);
		cards.push(
			this.createDummyCard(
				3,
				'Example card 3',
				'P-2',
				'Project 2',
				'Sprint 2',
				'',
				formatMessage({id: 'common.in_progress'}),
				2.5,
				1,
				1.5,
				'1 7 2017',
				'4 7 2017',
				'John Smith',
				formatMessage({id: 'common.no'}),
				formatMessage({id: 'common.no'}),
				formatMessage({id: 'common.yes'})
			)
		);
		return (
			<InsightList
				data={cards}
				labelsOptions={this.props.labelsOptions}
				componentName={this.props.componentName}
				allColumns={this.props.allColumns}
				activeColumns={this.props.activeColumns}
				scrollElement={this.props.scrollElement}
				notifyOnReady={this.props.notifyOnReady}
			/>
		);
	}
}

CardListPortfolioDummy.propTypes = {
	title: PropTypes.string,
};

export default injectIntl(CardListPortfolioDummy);
